import { themeBase } from './theme-base';

export const theme = {
  ...themeBase,

  badge: {
    color: Styles.color.tertiary,
  },
};
